(function() {
	'use strict';
	var $ = avm.require('cash');
})();

(function() {
	'use strict';

	/*  ----------------------------------
		Dynamic section - D3 graph
		---------------------------------- */
	var data,
		$ = avm.require('cash'),
		$window = $(window),
		locale = window.avastGlobals.web.locale.substring(3),
		customLocales = ['us', 'fr', 'br', 'ru'],
		url = '/api/v1/threat-stats?from=2015-01-01&to=2050-07-07',
		$around = $('#around'),
		$global = $('.js-global'),
		$local = $('.js-local'),
		$additional = $('.js-additional'),
		$users = $('.js-users'),
		thMil = function(number) {
			var users = number.toString(),
				separator = avastGlobals.web.numberThousandSeparator,
				arr = [],
				usersLength = users.length,
				str = '',
				value;

			for (var i = Math.ceil(usersLength / 3); i > 0; i--) {
				value = users.substring(usersLength - 3, usersLength);
				usersLength -= 3;
				arr.unshift(value);
			}
			for (var j = 0; j < arr.length; j++) {
				str += arr[j] + separator;
			}
			if (separator === '') {
				return str.substring(0, str.length + 1);
			} else {
				return str.substring(0, str.length - 1);
			}
		},
		// Graph
		margin = {
			top: 20,
			right: 0,
			bottom: 80,
			left: 150
		},
		width = 900 - margin.left - margin.right,
		height = 500 - margin.top - margin.bottom,
		x = d3.scale.ordinal().rangeRoundBands([0, width], 0.1),
		y = d3.scale.linear().range([height, 0]),
		xAxis = d3.svg.axis().scale(x).orient('bottom'),
		yAxis = d3.svg.axis().scale(y).orient('left'),
		svg = d3.select('#around .graph').append('svg')
			.attr('class', 'js-graph')
			.attr('width', width + margin.left + margin.right)
			.attr('height', height + margin.top + margin.bottom)
			.append('g')
			.attr('transform', 'translate(' + margin.left + ',' + margin.top + ')'),
		defs = 	d3.select('#around .graph svg g').append('defs')
			.append('linearGradient')
			.attr('id', 'grad')
			.attr('x1', '0%')
			.attr('y1', '0%')
			.attr('x2', '0%')
			.attr('y2', '100%')
			.append('stop')
			.attr('offset', '0%')
			.attr('style', 'stop-color:#ff7800;stop-opacity:1'),
		stop2 = d3.select('#around .graph #grad').append('stop')
			.attr('offset', '100%')
			.attr('style', 'stop-color:#ff9a41;stop-opacity:1'),

		revealStats = function(processedData) {
			svg.selectAll('.bar')
				.data(processedData)
				.enter()
				.append('rect')
				.attr('class', 'bar')
				.attr('x', function(d) {
					return x(d.week);
				})
				.attr('width', x.rangeBand() - 7)
				.attr('y', function(d) {
					return height - 0.5;
				})
				.attr('height', 0)
				.attr('fill', '#FF7800')
				.transition().delay(function(d, i) {
					return i * 50;
				}).duration(1500)
				.ease('bounce')
				.attr('y', function(d) {
					return y(d.users);
				})
				.attr('height', function(d) {
					return height - y(d.users) - 0.5;
				});
		};

	// execution according to locale
	if (customLocales.indexOf(locale) === -1) {
		// do for all other locales
		locale = 'XX'; // worldwide statistic
		$additional.hide();
		$local.hide();
	} else {
		// do for custom locales
		locale = locale.toUpperCase();
		$global.hide();
	}

	var xhr = new XMLHttpRequest();
	xhr.open('GET', url);
	xhr.setRequestHeader('X-Requested-With', 'XmlHttpRequest');
	xhr.onreadystatechange = function() {
		if (xhr.readyState !== 4) {
			return;
		}
		if (xhr.status === 200) {
			renderGraph(JSON.parse(xhr.responseText));
		} else {
			console.log('HTTP error', xhr.status, xhr.statusText);
		}
	};
	xhr.send();

	// get data for graph and render it
	function renderGraph(data) {
		// create array from data object for current country
		var processedData = [],
			$graph = $('.js-graph');
		for (var name in data) {
			processedData.push({
				week: name,
				users: data[name][locale].users
			});
		}

		// leave only last 30 items in array
		if (processedData.length > 30) {
			processedData = processedData.splice(processedData.length - 30);
		}

		// add data to sentences above graph with proper thousand milestones
		$users.html(thMil(processedData[processedData.length - 1].users));

		// Add graph
		x.domain(processedData.map(function(d) {
			return d.week;
		}));
		// y.domain([0, d3.max(processedData, function(d) { return d.users; })]);
		y.domain([0, d3.max(processedData, function(d) {
			return d.users / 6 + d.users;
		})]);

		svg.append('g')
			.attr('class', 'x axis')
		// .attr('transform', 'translate(0,' + height + ')')
			.attr('transform', 'translate(-3, 420)')
		//			.attr('transform', 'translate(-3, 460)')
			.call(xAxis);

		svg.append('g')
			.attr('class', 'y axis')
			.attr('transform', 'translate(0, 0)')
			.call(yAxis);

		// add circles to x axis
		d3.select('.x.axis')
			.selectAll('g.tick')
			.insert('circle', ':first-child')
			.attr('r', 5).style('fill', '#94A2AA');

		d3.selectAll('.x.axis g.tick text')
			.attr('y', 25);

		// Scroll to graph
		$window.on('scroll', function() {
			if ($around.offset().top + $around.height() - 200 < window.pageYOffset + window.innerHeight) {
				revealStats(processedData);
			}
		});

		// Responsive graph
		//		$window.on('resize', function () {
		//			$graph.attr('width', mediaQueryLogic().graphWidth);
		//		});
		//		$graph.attr('width', mediaQueryLogic().graphWidth);

		// on page load in viewport
		if ($around.offset().top + $around.height() - 200 < window.pageYOffset + window.innerHeight) {
			revealStats(processedData);
		}
	}
})();

var sliderMyCarousel = tns({
	container: '.slider-win10-av-reviews',
	controlsContainer: '.slider-win10-av-reviews-controls',
	controlsPosition: 'bottom',
	controls: false,
	navPosition: 'bottom',
	mouseDrag: true,
	speed: 400,
	fixedWidth: 304,
	preventScrollOnTouch: 'auto',
	responsive: {
		576: {
			center: true
		},
		768: {
			items: 2,
			slideBy: 2,
			controls: true,
			center: false
		},
		1280: {
			fixedWidth: 408
		},
		1366: {
			fixedWidth: 436
		},
		1600: {
			fixedWidth: 464
		}
	}
});


/*  ----------------------------------
	GLOWEB-5636
---------------------------------- */
if ($(".slider-win10-av-reviews-gloweb-5636-variant-b").length > 0) {

	var sliderMyCarouselVariantB = tns({
		container: '.slider-win10-av-reviews-gloweb-5636-variant-b',
		controlsContainer: '.slider-win10-av-reviews-gloweb-5636-variant-b-controls',
		controlsPosition: 'bottom',
		controls: false,
		navPosition: 'bottom',
		mouseDrag: true,
		speed: 400,
		fixedWidth: 304,
		preventScrollOnTouch: 'auto',
		responsive: {
			576: {
				center: true
			},
			768: {
				items: 2,
				slideBy: 2,
				controls: true,
				center: false
			},
			1280: {
				fixedWidth: 408
			},
			1366: {
				fixedWidth: 436
			},
			1600: {
				fixedWidth: 464
			}
		}
	});
}
/*  ----------------------------------
	/GLOWEB-5636
---------------------------------- */
